import styled from 'styled-components';

import { media, themed } from '@/shared/ui/core';

export const PageHeaderStyled = styled.header`
  height: calc(${themed('header.height')} + var(--notch-height));
  line-height: ${themed('header.height')};
  background-color: white;
  z-index: 100;
  position: sticky;
  top: 0;

  @media ${media.desktopMin} {
    align-items: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    height: 5rem;
    line-height: initial;
    padding: 0;
  }

  .Title {
    font-size: 1.25rem;
    text-align: center;
    max-width: calc(100% - 6.5rem);
    color: ${themed('primary.text')};
    margin: auto;
    z-index: 110;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media ${media.mobileMax} {
    .Title {
      width: 100%;
      max-width: 26rem;
    }
  }

  @media ${media.desktopMin} {
    .Title {
      display: none;
    }

    .Logo {
      display: block;
    }
  }
`;

export const Logo = styled.div.attrs({
  className: 'Logo',
})`
  width: 100%;
  max-width: calc(57.5rem - 2.50rem);
  margin: auto;
  display: none;

  svg {
    > path:nth-of-type(1) {
      fill: ${themed('primary.main')};
    }

    > g:nth-of-type(1) {
      fill: ${themed('primary.accent')};
    }
  }
`;
